import { jsx as r } from "react/jsx-runtime";
import { LoadingSearchBar as n } from "@intergamma/search-bar";
import { cn as o } from "@intergamma/common/cn";
function a({
  className: l,
  children: t,
  ...i
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      className: o(
        "w-full",
        "md:w-full lg:relative lg:inset-x-auto lg:top-0 lg:z-[11] lg:w-56 lg:transition-[right] lg:duration-100",
        "xl:ml-8 xl:w-[376px]",
        l
      ),
      ...i,
      children: t
    }
  );
}
function c() {
  return /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r(n, {}) });
}
export {
  c as L,
  a as S
};
